import ScreenLayout from "@/components/layout/screen-layout";
import { Button } from "@/components/ui/button";
import { ImgCaseStudiesBg } from "@/lib/images";
import Image from "next/image";

function CaseStudyHeroSection() {
    const scrollToNextSection = () => {
        const nextSection = document.querySelector('.case-studies-content');
        if (nextSection) {
            nextSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <ScreenLayout
            outerClassName="relative overflow-hidden"
            className="pt-35 md:pt-55 pb-10 md:pb-21.25"
            style={{
                border: '1px solid #000',
            }}
        >
            {/* Background Image */}
            <div className="absolute inset-0 z-0">

                {/* Gradient Overlay */}
                <div
                    className="absolute inset-0 h-full w-full"
                    style={{
                        background: 'linear-gradient(105deg, rgba(0, 9, 41, 0.9) 0.42%, rgba(0, 31, 143, 0.9) 99.58%)'
                    }}
                />

                <Image
                    src={ImgCaseStudiesBg}
                    alt="Case Studies Background"
                    fill
                    className="object-cover md:object-cover h-full w-full"
                    priority
                />
            </div>

            <div className="flex flex-col justify-center items-center text-center relative z-10">
                {/* Heading Section */}
                <div className="flex justify-center mb-6">
                    <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-4xl xl:text-[53.16px] font-semibold text-white text-center max-w-4xl px-4">
                        Pushing Boundaries: Tales of Innovation
                    </h1>
                </div>

                {/* Sub Heading Section */}
                <div className="flex justify-center mb-8">
                    <p className="text-sm sm:text-base md:text-xl text-center font-normal text-white/80 max-w-4xl px-4">
                        Step into the world where ideas meet execution. These compelling narratives showcase how we've helped businesses innovate, adapt, and lead in their respective industries.
                    </p>
                </div>

                {/* Button Section */}
                <div className="flex justify-center">
                    <Button
                        onClick={scrollToNextSection}
                        variant="secondary"
                        size="sm"
                        className="text-custom-blue text-sm sm:text-base rounded-full px-6 h-12"
                    >
                        Read Case Studies
                    </Button>
                </div>
            </div>
        </ScreenLayout>
    );
}

export default CaseStudyHeroSection; 